const formReducerDefaultState = [
  {
    isCarer: null,
    serviceType: null,
    patientAge: null,
    patientGender: null,
    patientLivingArrangements: null,
    patientPostcode: null,
    patientTransportToHospital: null,
    patientTransportOther: null,
    patientEthnicity: null,
    patientGenderIdentity: null,
    patientGenderAtBirth: null,
    patientSexualOrientation: null,
    safeSevenOne: null,
    safeSevenTwo: null,
    safeSevenThree: null,
    safeSevenFour: null,
    safeSevenFive: null,
    safeSevenSix: null,
    safeSevenSeven: null,
    patientGoodExperience: null,
    patientBadExperience: null,
    formState: 'start',
    key: null,
  },
];

export const formReducer = (state = formReducerDefaultState, action) => {
  switch (action.type) {
    case 'MODIFY_FORM':
      return [action.form];
    default:
      return state;
  }
};

//Language reducer
const languageReducerDefaultState = {
  selectedLanguage: "en",
  tokenLanguage: null,
  translations: {},
  isLoading: true
};

export const languageReducer = (state = languageReducerDefaultState, action) => {
  switch (action.type) {
    case 'SET_LANGUAGE':
      return {
        ...state,
        selectedLanguage: action.language
      };
    case 'SET_TRANSLATIONS':
      return {
        ...state,
        translations: action.translations,
        isLoading: false
      };
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: action.isLoading
      };
    case 'CLEAR_LANGUAGE':
      return {
        ...languageReducerDefaultState
      };
    default:
      return state;
  }
};